import api from "@/api/api_instance";
import { AppResponse } from "@/types/app.types";

import { AuthEndpoints } from "../constants/auth.endpoints";
import {
  GetOtpResponse,
  GetRelationUserParams,
  GetWebKeyResponse,
  UserDef,
} from "../types/auth.types";

export const fetchWebKey = (
  fingerprint: string
): Promise<GetWebKeyResponse> => {
  return api.get(AuthEndpoints.WEB_KEY, {
    params: {
      fingerprint,
    },
  });
};

export const getCurrentUsername = (): Promise<UserDef> => {
  return api.get(AuthEndpoints.profile(-1));
};

export const getRelationUser = (
  params: GetRelationUserParams,
  signal: AbortSignal
): Promise<UserDef[]> => {
  return api.get(AuthEndpoints.RELATIONSHIP, {
    params,
    signal,
  });
};

export const clearAuthToken = (): Promise<void> => {
  return api.get(AuthEndpoints.LOGOUT);
};

export const getOtp = (): Promise<GetOtpResponse> => {
  return api.get(AuthEndpoints.OTP);
};

export const getLibraryId = (): Promise<AppResponse<number>> => {
  return api.get(AuthEndpoints.LIBRARY_ID);
};

export const fetchCookieSession = (
  fingerprint: string
): Promise<AppResponse<string>> => {
  return api.get(AuthEndpoints.COOKIE_SESSION, {
    params: {
      fingerprint,
    },
  });
};
